module.exports = __webpack_public_path__ + "static/media/redirects sample data.308adc53.csv";